<script>
import {onMounted, ref} from "vue";
import axios from "axios";
import useTools from "@/use/Tools";
import useSharedMethod from "@/use/SharedMethod";

export default {
    name: "DejaVu",
    props: {
        cvTechSourcingId: Number,
        viewAction: Boolean,
        small: Boolean,
    },
    setup(props) {
        const dialog = ref(false);
        const loading = ref(false);
        const dejaVu = ref([]);

        const {$i18n, $router} = useTools();
        const {formatedDate, formatedTime} = useSharedMethod();

        const headers = [
            {
                text: $i18n.t("common.code"),
                align: "left",
                value: "sourcingRequestCode",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("recruitment_request.recruitment_date"),
                align: "left",
                value: "sourcingRequestLaunchDate",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("recruitment_request.requesting_agency"),
                align: "left",
                value: "sourcingRequestRequestingAgencyName",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("recruitment_request.applicant"),
                align: "left",
                value: "sourcingRequestWorkerLastName",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("recruitment_request.occupation"),
                align: "left",
                value: "sourcingRequestOccupationName",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("recruitment_request.state"),
                align: "left",
                value: "sourcingRequestState",
                sortable: true,
                width: "0%"
            },
            {
                text: "Source",
                align: "left",
                value: "source",
                sortable: true,
                width: "0%"
            },
            {
                text: "Etat",
                align: "left",
                value: "state",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("recruitment_request.closed_date"),
                align: "left",
                value: "sourcingRequestClosedDate",
                sortable: true,
            },
            {
                text: "",
                sortable: false,
                align: "left",
                value: "view",
            },
        ];

        const candidateHeaders = [
            {
                text: $i18n.t("common.type"),
                align: "left",
                value: "planningTypeName",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t('common.date'),
                sortable: true,
                align: "left",
                value: "planningDate",
                width: "0%"
            },
            {
                text: $i18n.t('common.hour'),
                sortable: true,
                align: "left",
                value: "timing",
                width: "0%"
            },
            {
                text: $i18n.t("recruitment_request.principal_expert"),
                align: "left",
                value: "planningPrincipalExpertName",
                sortable: true,
                width: "0%"
            },
            {
                text: "Confirmé",
                sortable: false,
                align: "left",
                value: "confirmed",
                width: "0%"
            },
            {
                text: "Effectué",
                sortable: false,
                align: "left",
                value: "done",
                width: "0%"
            },
            {
                text: "Decision",
                sortable: false,
                align: "left",
                value: "interviewDecision",
                width: "0%"
            },
            {
                text: "Note",
                sortable: false,
                align: "left",
                value: "interviewNote",
                width: "0%"
            },
            {
                text: "",
                sortable: false,
                align: "left",
                value: "interview",
            },
        ];

        function check() {
            loading.value = true;
            axios.get(`/cvTechSourcings/dejaVu/${props.cvTechSourcingId}`).then(response => {
                dejaVu.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        function viewCandidateCvTech(item) {
            $router.push({name: 'recruitment_sourcings.cv_techs.view', params: {id: item.cvTechId}});
        }

        onMounted(() => check());

        return {
            loading,
            dialog,
            headers,
            candidateHeaders,
            dejaVu,
            check,
            formatedDate,
            formatedTime,
            viewCandidateCvTech
        }
    }
}

</script>

<template>
    <div>

        <v-dialog
            v-model="dialog"
            max-width="1600"
        >
            <v-card>
                <v-toolbar flat height="40" color="red">
                    <v-toolbar-title class="white--text">Déjà Vu</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container fluid>
                        <w-data-table
                            :headers="headers"
                            :items="dejaVu"
                            disable-pagination
                            :loading="loading"
                            sort-by="sourcingRequestLaunchDate"
                            descending
                            show-expand
                            single-expand
                        >
                            <template v-slot:item.sourcingRequestCode="{ item }">
                                <w-chip color="teal" :text="item.sourcingRequestCode"/>
                            </template>
                            <template v-slot:item.sourcingRequestLaunchDate="{ item }">
                                <w-chip color="teal" outlined :text="formatedDate(item.sourcingRequestLaunchDate)"/>
                            </template>
                            <template v-slot:item.sourcingRequestWorkerLastName="{ item }">
                                <w-chip color="blue darken-2" outlined :text="item.sourcingRequestWorkerName"/>
                            </template>
                            <template v-slot:item.sourcingRequestRequestingAgencyName="{ item }">
                                <w-chip color="blue darken-2" :text="item.sourcingRequestRequestingAgencyName"/>
                            </template>
                            <template v-slot:item.sourcingRequestOccupationName="{ item }">
                                <w-chip color="blue darken-2" outlined :text="item.sourcingRequestOccupationName"/>
                            </template>
                            <template v-slot:item.sourcingRequestState="{ item }">
                                <w-chip color="deep-orange" :text="$t(`recruitment_request.${item.sourcingRequestState}`)"/>
                            </template>
                            <template v-slot:item.source="{ item }">
                                <w-chip outlined :text="$t(`recruitment_request.${item.source}`)"/>
                            </template>
                            <template v-slot:item.state="{ item }">
                                <w-chip outlined :text="$t(`cv_tech_sourcing.${item.state}`)"/>
                            </template>
                            <template v-slot:item.sourcingRequestCloseDate="{ item }">
                                <w-chip color="deep-orange" :text="formatedDate(item.sourcingRequestCloseDate)"/>
                            </template>
                            <template v-slot:[`item.view`]="{ item }">
                                <v-btn
                                    v-if="viewAction"
                                    icon
                                    color="blue darken -2"
                                    @click="viewCandidateCvTech(item)"
                                >
                                    <v-icon>mdi-cube-scan</v-icon>
                                </v-btn>
                            </template>
                            <template v-slot:expanded-item="{ headers, item }">
                                <td></td>
                                <td :colspan="headers.length - 1">
                                    <v-container fluid>
                                        <w-data-table
                                            :headers="candidateHeaders"
                                            :items="item.candidates"
                                            sort-by="planningDate"
                                            descending
                                            disable-pagination
                                        >
                                            <template v-slot:item.planningTypeName="{ item }">
                                                <v-chip outlined label small>
                                                    <strong>{{ item.planningTypeName }}</strong>
                                                </v-chip>
                                            </template>
                                            <template v-slot:item.planningDate="{item}">
                                                <v-chip label small outlined>
                                                    <strong>
                                                        <a>{{ formatedDate(item.planningDate) }}</a>
                                                    </strong>
                                                </v-chip>
                                            </template>
                                            <template v-slot:item.timing="{item}">
                                                <v-chip label small outlined>
                                                    <strong>
                                                        <a>{{ formatedTime(item.timing) }}</a>
                                                    </strong>
                                                </v-chip>
                                            </template>
                                            <template v-slot:item.planningPrincipalExpertName="{ item }">
                                                <v-chip outlined label small>
                                                    <strong>{{ item.planningPrincipalExpertName }}</strong>
                                                </v-chip>
                                            </template>
                                            <template v-slot:[`item.confirmed`]="{ item }">
                                                <v-simple-checkbox
                                                    :value="item.confirmed"
                                                    color="blue"
                                                />
                                            </template>
                                            <template v-slot:[`item.done`]="{ item }">
                                                <v-simple-checkbox
                                                    :value="item.done"
                                                    color="blue"
                                                />
                                            </template>
                                            <template v-slot:[`item.interviewDecision`]="{ item }">
                                                <v-chip label small v-if="item.interviewDecision && item.done">
                                                    <strong>{{ $t(`recruitment_request.evaluation_decision_${item.interviewDecision}`) }}</strong>
                                                </v-chip>
                                            </template>
                                            <template v-slot:[`item.interviewNote`]="{ item }">
                                                <v-chip small color="blue" outlined v-if="item.interviewNote && item.done">
                                                    <strong>{{ item.interviewNote }}</strong>
                                                </v-chip>
                                            </template>
                                            <template v-slot:[`item.interview`]="{ item }">
                                                <v-btn
                                                    v-if="viewAction && item.done"
                                                    icon
                                                    color="blue darken -2"
                                                    @click="$router.push({name: `evaluation_recruitment_sourcings.interview.view`, params: {id: item.id}});"
                                                >
                                                    <v-icon>mdi-clipboard-text-clock</v-icon>
                                                </v-btn>
                                            </template>
                                        </w-data-table>
                                    </v-container>
                                </td>
                            </template>
                        </w-data-table>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>


        <v-chip
            v-if="dejaVu.length > 0"
            :small="small"
            label
            color="red"
            outlined
            @click="dialog = true"
        >
            <strong>{{ dejaVu.length }} Déjà Vu</strong>
        </v-chip>
        <v-progress-circular
            v-if="loading"
            indeterminate
            color="red"
        />
    </div>
</template>